<div class="julia-block">
  <div class="block-toolbar">
    <span class="block-count" *ngIf="page">
      {{ 'julia.blocks.rows_range' | translate : { first: first, last: last, total: page.total } }}
    </span>
    <button class="block-btn" *ngIf="!child" (click)="download()" [disabled]="exporting">
      {{ (exporting ? 'julia.blocks.exporting' : 'julia.blocks.export') | translate }}
    </button>
  </div>

  <div class="block-error" *ngIf="error">{{ error | translate }}</div>

  <div class="block-table-wrapper" [class.loading]="loading" *ngIf="page">
    <table class="block-table">
      <thead>
        <tr>
          <th *ngFor="let column of columns" (click)="toggleSort(column)">
            {{ title(column) }} <span class="sort-icon">{{ sortIcon(column) }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of page.rows; let r = index">
          <td *ngFor="let column of columns; let c = index">
            <a *ngIf="isLinkColumn(c) && link(r) as href; else plain"
               [href]="href" (click)="open($event, href)">{{ cell(row, column) }}</a>
            <ng-template #plain>{{ cell(row, column) }}</ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="block-pager" *ngIf="page && pages > 1">
    <button class="block-btn" (click)="go(page.page - 1)" [disabled]="page.page <= 1 || loading">
      {{ 'julia.blocks.previous' | translate }}
    </button>
    <span>{{ page.page }} / {{ pages }}</span>
    <button class="block-btn" (click)="go(page.page + 1)" [disabled]="page.page >= pages || loading">
      {{ 'julia.blocks.next' | translate }}
    </button>
  </div>
</div>
